import React, { Component } from "react";

import {
  Card,
  Button,
  Table,
  Tooltip,
  Select,
  Input,
  BackTop,
  Modal,
  message,
  Tag,
} from "antd";

import { connect } from "react-redux";
import {
  req_page_eca_english_activity,
  req_delete_eca_english_activity,
  req_edit_eca_english_activity,
} from "../../api";

import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import {
  getNowAcademicYear,
  getNowAcademicSemester,
} from "../../utils/dateUtil";
import { formateDate } from "../../utils/dateUtil";
import memoryUtils from "../../utils/memoryUtils";

import EnglishActivityAdd from "./english-activity-add-modal";

class UIEnglishActivity extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",

    domnloadFile: "",

    nowAcademicYear: getNowAcademicYear(new Date()),
    nowAcademicSemester: getNowAcademicSemester(new Date()),

    isShowModal: false,
    isEditModal: false,
    isAddModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  // componentWillUnmount() {
  //     window.removeEventListener("resize", this.resize.bind(this))
  // }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = (current) => {
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      nowAcademicYear,
      nowAcademicSemester,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    //採用(母母視窗模式)
    if (memoryUtils.pagination.isGoBack) {
      const nowAcademicYear = memoryUtils.pagination.academicYear;
      const nowAcademicSemester = memoryUtils.pagination.academicSemester;
      // 標準
      this.current = memoryUtils.pagination.current;
      const pageSize = memoryUtils.pagination.pageSize;
      const columnSort = memoryUtils.pagination.columnSort;
      const orderBy = memoryUtils.pagination.orderBy;
      const searchField = memoryUtils.pagination.searchField;
      const searchValue = memoryUtils.pagination.searchValue;
      const filterStatus = memoryUtils.pagination.filterStatus;
      this.setState(
        {
          nowAcademicYear,
          nowAcademicSemester,
          current,
          pageSize,
          columnSort,
          orderBy,
          searchField,
          searchValue,
          filterStatus,
        },
        () => {
          this.api_page_run(
            userCode,
            userLevel,
            nowAcademicYear,
            nowAcademicSemester,
            current,
            pageSize,
            columnSort,
            orderBy,
            searchField,
            searchValue,
            filterStatus,
            token,
          );
        },
      );
    } else {
      this.current = current; // 保存當前頁，給其他方法可看到
      this.api_page_run(
        userCode,
        userLevel,
        nowAcademicYear,
        nowAcademicSemester,
        current,
        pageSize,
        columnSort,
        orderBy,
        searchField,
        searchValue,
        filterStatus,
        token,
      );
    }

    if (memoryUtils.pagination.isGoBack) {
      memoryUtils.pagination.isGoBack = false;
    }
  };

  api_page_run = async (
    userCode,
    userLevel,
    nowAcademicYear,
    nowAcademicSemester,
    current,
    pageSize,
    columnSort,
    orderBy,
    searchField,
    searchValue,
    filterStatus,
    token,
  ) => {
    this.setState({ loading: true });
    const result = await req_page_eca_english_activity(
      userCode,
      userLevel,
      nowAcademicYear,
      nowAcademicSemester,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token,
    );
    //console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
    this.setState({ loading: false });
  };

  api_modify_item = async (item) => {
    const { token } = this.props.user;
    await req_edit_eca_english_activity(item, token);
  };

  api_delete_item = async (key) => {
    const { token } = this.props.user;
    const result = await req_delete_eca_english_activity(key, token);

    if (result.status === "success") {
      message.success("刪除成功");
      this.api_page_items(this.current);
      this.handle_data_refresh();
    } else {
      //console.log(result)
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    const nowAcademicYear = getNowAcademicYear(new Date());
    const nowAcademicSemester = getNowAcademicSemester(new Date());
    this.setState({ nowAcademicYear, nowAcademicSemester });
    this.columns = [
      {
        title: "分類",
        width: 30,
        responsive: ["md"],
        render: (item) => {
          const { activityTypeCode } = item;
          return (
            <div className="text-center">
              <Tag color={this.style_switch_color_tag(activityTypeCode)}>
                {this.style_switch_text_tag(activityTypeCode)}
              </Tag>
            </div>
          );
        },
      },
      {
        title: "學年度",
        dataIndex: "AcademicYear",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "學期",
        dataIndex: "AcademicSemester",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "主旨",
        dataIndex: "activityTitle",
        width: 100,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "開始時間",
        width: 40,
        responsive: ["md"],
        render: (englishactivity) => {
          const { activityStartDate } = englishactivity;
          return <>{formateDate(activityStartDate)}</>;
        },
      },
      {
        title: "結束時間",
        width: 40,
        responsive: ["md"],
        render: (englishactivity) => {
          const { activityEndDate } = englishactivity;
          return <>{formateDate(activityEndDate)}</>;
        },
      },
      {
        title: "登載者",
        dataIndex: "recordCreateAccountName",
        width: 30,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "預劃點數",
        width: 25,
        render: (item) => {
          const { setPoints, activityNid } = item;
          return (
            <>
              {" "}
              <Input
                style={{
                  width: 60,
                  margin: "0 5px",
                  backgroundColor: "LightYellow",
                }}
                defaultValue={setPoints}
                onChange={(e) =>
                  this.handle_ui_field_change(activityNid, "ALLPOINTS", e)
                }
              />
            </>
          );
        },
      },
      {
        title: "",
        dataIndex: "",
        width: 65,
        render: (englishactivity) => {
          //const { board } = englishactivity
          return (
            <>
              <button
                type="button"
                className="btn btn-outline-dark btn-sm"
                onClick={() =>
                  this.handle_pages_next_stautus(
                    "/learnpoints/activity/participates",
                    englishactivity,
                  )
                }
              >
                <i className="fas fa-user-friends"></i>
                <span style={{ marginLeft: "2px" }}>參加人員</span>
              </button>
              <button
                type="button"
                className="btn btn-outline-dark btn-sm"
                onClick={() =>
                  this.handle_show_ui_modal("delete", englishactivity)
                }
              >
                <i className="fas fa-minus"></i>
                <span> 刪除</span>
              </button>
            </>
          );
        },
      },
    ];
  };

  style_switch_text_tag(column) {
    let ans = "其他";
    switch (column) {
      case "BASE":
        ans = "講座"; // 其他 / 1246
        break;
      case "STUDY": // 研習活動 / 5
        ans = "潛能班";
        break;
      case "GAME":
        ans = "比賽"; // 比賽活動 / 3
        break;
      case "GRAMMER":
        ans = "文法";
        break;
      case "TALK":
        ans = "對話";
        break;
      case "READ":
        ans = "閱讀";
        break;
      case "WRITE":
        ans = "寫作";
        break;
      case "TEST":
        ans = "自學測驗";
        break;
      case "SPECIAL":
        ans = "特別班";
        break;
      case "LICENCE":
        ans = "證照抵免";
        break;
      case "STRATEGY":
        ans = "多益閱讀";
        break;
      case "LISTEN":
        ans = "多益聽力";
        break;
      case "ARTICLE":
        ans = "自學文章";
        break;

      default:
        // OTHER
        break;
    }
    return ans;
  }

  style_switch_color_tag(column) {
    let ans = "其他";
    switch (column) {
      case "BASE":
        ans = "#87d068"; // 其他 / 1246
        break;
      case "STUDY": // 研習活動 / 5
        ans = "#108ee9";
        break;
      case "GAME":
        ans = "#f50"; // 比賽活動 / 3
        break;
      case "GRAMMER":
        ans = "magenta";
        break;
      case "LISTEN":
        ans = "magenta";
        break;
      case "TALK":
        ans = "magenta";
        break;
      case "READ":
        ans = "magenta";
        break;
      case "WRITE":
        ans = "magenta";
        break;
      case "TEST":
        ans = "MediumVioletRed";
        break;
      case "SPECIAL":
        ans = "magenta";
        break;
      case "LICENCE":
        ans = "magenta";
        break;
      case "STRATEGY":
        ans = "magenta";
        break;
      case "ARTICLE":
        ans = "magenta";
        break;
      default:
        ans = "gold";
        break;
    }
    return ans;
  }

  style_switch_point_tag(column) {
    let ans = "其他";
    switch (column) {
      case "STUDY": //活動-研習活動 / 5
        ans = 5;
        break;
      case "BASE": //活動-其他 / 1246
        ans = 1;
        break;
      case "GAME": //活動-比賽活動 / 3
        ans = 1;
        break;
      case "TALK":
        ans = 1;
        break;
      case "TEST":
        ans = 1;
        break;
      case "GRAMMER":
        ans = 0.5;
        break;
      case "LISTEN":
        ans = 0.5;
        break;
      case "READ":
        ans = 0.5;
        break;
      case "WRITE":
        ans = 0.5;
        break;
      case "SPECIAL":
        ans = 0;
        break;
      case "LICENCE":
        ans = 0;
        break;
      case "STRATEGY":
        ans = 0;
        break;
      case "ARTICLE":
        ans = 0;
        break;
      default:
        // OTHER
        ans = 0.5;
        break;
    }
    return ans;
  }

  // 操作互動處理 //////////////////////////////////////////////

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      },
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowModal: true, item });
        break;
      case "edit":
        this.setState({ isEditModal: true, item });
        break;
      case "add":
        this.setState({ isAddModal: true });
        break;
      case "delete":
        const { activityNid } = item;
        Modal.confirm({
          title: `您確定刪除此筆數據`,
          onOk: () => {
            this.api_delete_item(activityNid);
          },
        });
        break;
      case "download":
        break;
      default:
    }
  };

  handle_pages_next_stautus = (url, item) => {
    // memoryUtils.pagination.isGoNext = true
    const {
      nowAcademicYear,
      nowAcademicSemester,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
    } = this.state;
    memoryUtils.pagination.academicYear = nowAcademicYear;
    memoryUtils.pagination.academicSemester = nowAcademicSemester;

    memoryUtils.pagination.current = this.current;
    memoryUtils.pagination.pageSize = pageSize;
    memoryUtils.pagination.columnSort = columnSort;
    memoryUtils.pagination.orderBy = orderBy;
    memoryUtils.pagination.searchField = searchField;
    memoryUtils.pagination.searchValue = searchValue;
    memoryUtils.pagination.filterStatus = filterStatus;

    this.props.history.push(url, item);
  };

  handle_ui_field_change = (target_key, target_field, e) => {
    const value = e.target.value;
    const item = {
      activityNid: target_key,
      setPoints: value,
      condition: target_field,
    };
    //console.log(target_key)
    this.api_modify_item(item);
  };

  /////////////////////////////////////////////////////////////

  render() {
    const {
      loading,
      items,
      pagination,
      searchField,
      searchValue,
      nowAcademicYear,
      nowAcademicSemester,
      isAddModal,
    } = this.state;
    const title = (
      <span>
        <Input
          placeholder="學年"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={nowAcademicYear}
          onChange={(event) =>
            this.setState({ nowAcademicYear: event.target.value })
          }
        />
        <Input
          placeholder="學期"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={nowAcademicSemester}
          onChange={(event) =>
            this.setState({ nowAcademicSemester: event.target.value })
          }
        />
        <Select
          value={searchField}
          style={{ width: 120, backgroundColor: "LightCyan" }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="activityTitle">主旨</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 80, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>
        <p />
        <Button
          type="primary"
          onClick={() => this.handle_show_ui_modal("add", "")}
        >
          <i className="fas fa-plus"></i>
          <span style={{ marginLeft: "4px" }}>增加</span>
        </Button>
      </span>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="activityNid"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          visible={isAddModal}
          width={1000}
          onOk={() => {
            this.setState({ isAddModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isAddModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <EnglishActivityAdd />
        </Modal>
        <BackTop visibilityHeight="80" />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {},
)(UIEnglishActivity);
